module.exports = __webpack_public_path__ + "img/LV4.5b1f0b64.webp";